export default __webpack_public_path__ + "static/media/March_06.bae3180d.png";